import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function Objections() {
  const without = ['Confusión total sobre por dónde empezar', 'Tutoriales sueltos que no conectan entre sí', 'Cero progreso real después de meses', 'Falta de estructura y metodología', 'Frustración constante al practicar'];
  const withKit = ['Ruta de aprendizaje clara y probada', 'Academia completa paso a paso', 'Dominio de múltiples instrumentos', 'Aprendizaje guiado y estructurado', 'Progreso musical real y medible'];
  return <section className="py-16 md:py-20 bg-navy relative overflow-hidden" data-id="element-116">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[500px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-117"></div>
      <div className="absolute top-10 left-10 w-72 h-72 bg-magenta/8 rounded-full blur-3xl pointer-events-none" data-id="element-118"></div>
      <div className="absolute bottom-10 right-10 w-72 h-72 bg-cyan/8 rounded-full blur-3xl pointer-events-none" data-id="element-119"></div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-120">
        <FadeIn data-id="element-121">
          <p className="text-center text-gold uppercase tracking-[0.3em] text-xs md:text-sm font-bold mb-3" data-id="element-122">
            Compará
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-center text-beige mb-12" data-id="element-123">
            La diferencia es <span className="text-gold" data-id="element-124">abismal</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-125">
          {/* SIN MUSIC PRO KIT */}
          <FadeIn data-id="element-126">
            <div className="bg-navy-light border border-red-500/25 rounded-2xl p-6 md:p-8 h-full" data-id="element-127">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-red-500/15" data-id="element-128">
                <div className="w-10 h-10 rounded-full bg-red-500/15 flex items-center justify-center" data-id="element-129">
                  <XCircle className="w-6 h-6 text-red-400" data-id="element-130" />
                </div>
                <h3 className="text-xl md:text-2xl font-black text-beige" data-id="element-131">
                  SIN MUSIC PRO KIT
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-132">
                {without.map((item, index) => <li key={index} className="flex items-start gap-3 text-base text-beige/80" data-id="element-133">
                    <XCircle className="w-5 h-5 text-red-400/80 flex-shrink-0 mt-0.5" data-id="element-134" />
                    <span data-id="element-135">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* CON MUSIC PRO KIT */}
          <FadeIn delay={0.15} data-id="element-136">
            <div className="bg-navy-light border-2 border-gold/40 rounded-2xl p-6 md:p-8 h-full shadow-[0_0_40px_rgba(255,200,61,0.1)] relative" data-id="element-137">
              <div className="absolute -top-3 right-6 bg-gold text-navy text-[10px] md:text-xs font-black uppercase px-3 py-1 rounded-full tracking-wider" data-id="element-138">
                Tu nueva realidad
              </div>
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gold/20" data-id="element-139">
                <div className="w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center" data-id="element-140">
                  <CheckCircle2 className="w-6 h-6 text-gold" data-id="element-141" />
                </div>
                <h3 className="text-xl md:text-2xl font-black text-beige" data-id="element-142">
                  CON <span className="text-gold" data-id="element-143">MUSIC PRO KIT</span>
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-144">
                {withKit.map((item, index) => <li key={index} className="flex items-start gap-3 text-base text-beige" data-id="element-145">
                    <CheckCircle2 className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" data-id="element-146" />
                    <span className="font-medium" data-id="element-147">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}